"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Insights
 * OpenApi specification for the Insights.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.WidgetSchemaToJSON = exports.WidgetSchemaFromJSONTyped = exports.WidgetSchemaFromJSON = exports.instanceOfWidgetSchema = exports.WidgetSchemaKindEnum = void 0;
var runtime_1 = require("../runtime");
var LocaleTranslations_1 = require("./LocaleTranslations");
var WidgetConfigurations_1 = require("./WidgetConfigurations");
var WidgetLayout_1 = require("./WidgetLayout");
var _1 = require("./");
/**
 * @export
 */
exports.WidgetSchemaKindEnum = {
    Placeholder: 'placeholder',
    ObservationPipeline: 'observationPipeline',
    CoverageScore: 'coverageScore',
    FleetHealthOverview: 'fleetHealthOverview',
    SensorsManifestOverview: 'sensorsManifestOverview',
    ReleaseOverview: 'releaseOverview',
    LoginByCountryMap: 'loginByCountryMap',
    BarChart: 'barChart',
    PieChart: 'pieChart',
    Table: 'table',
    AreaChart: 'areaChart',
    HorizontalBarChart: 'horizontalBarChart',
    BubbleMap: 'bubbleMap',
    GroupBarChart: 'groupBarChart',
    MultiAreaChart: 'multiAreaChart'
};
/**
 * Check if a given object implements the WidgetSchema interface.
 */
function instanceOfWidgetSchema(value) {
    var isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "layout" in value;
    isInstance = isInstance && "kind" in value;
    return isInstance;
}
exports.instanceOfWidgetSchema = instanceOfWidgetSchema;
function WidgetSchemaFromJSON(json) {
    return WidgetSchemaFromJSONTyped(json, false);
}
exports.WidgetSchemaFromJSON = WidgetSchemaFromJSON;
function WidgetSchemaFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    if (!ignoreDiscriminator) {
        if (json['kind'] === 'areaChart') {
            return (0, _1.AreaChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'barChart') {
            return (0, _1.BarChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'bubbleMap') {
            return (0, _1.BubbleMapWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'coverageScore') {
            return (0, _1.CoverageScoreWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'fleetHealthOverview') {
            return (0, _1.FleetHealthOverviewWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'groupBarChart') {
            return (0, _1.GroupBarChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'horizontalBarChart') {
            return (0, _1.HorizontalBarChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'loginByCountryMap') {
            return (0, _1.LoginByCountryMapWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'multiAreaChart') {
            return (0, _1.MultiAreaChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'observationPipeline') {
            return (0, _1.ObservationPipelineWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'pieChart') {
            return (0, _1.PieChartWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'placeholder') {
            return (0, _1.PlaceholderWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'releaseOverview') {
            return (0, _1.ReleaseOverviewWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'sensorsManifestOverview') {
            return (0, _1.SensorsManifestOverviewWidgetSchemaFromJSONTyped)(json, true);
        }
        if (json['kind'] === 'table') {
            return (0, _1.TableWidgetSchemaFromJSONTyped)(json, true);
        }
    }
    return {
        'id': json['id'],
        'title': (0, LocaleTranslations_1.LocaleTranslationsFromJSON)(json['title']),
        'description': !(0, runtime_1.exists)(json, 'description') ? undefined : (0, LocaleTranslations_1.LocaleTranslationsFromJSON)(json['description']),
        'layout': (0, WidgetLayout_1.WidgetLayoutFromJSON)(json['layout']),
        'config': !(0, runtime_1.exists)(json, 'config') ? undefined : (0, WidgetConfigurations_1.WidgetConfigurationsFromJSON)(json['config']),
        'dataSource': !(0, runtime_1.exists)(json, 'dataSource') ? undefined : json['dataSource'],
        'kind': json['kind'],
    };
}
exports.WidgetSchemaFromJSONTyped = WidgetSchemaFromJSONTyped;
function WidgetSchemaToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'title': (0, LocaleTranslations_1.LocaleTranslationsToJSON)(value.title),
        'description': (0, LocaleTranslations_1.LocaleTranslationsToJSON)(value.description),
        'layout': (0, WidgetLayout_1.WidgetLayoutToJSON)(value.layout),
        'config': (0, WidgetConfigurations_1.WidgetConfigurationsToJSON)(value.config),
        'dataSource': value.dataSource,
        'kind': value.kind,
    };
}
exports.WidgetSchemaToJSON = WidgetSchemaToJSON;
